import { Model } from '@vuex-orm/core'
import VitalEntry from './VitalEntry'

export default class VitalValue extends Model {
  static entity = 'vitalValues'

  static fields () {
    return {
      id: this.attr(null),
      vital_entry_id: this.attr(null),
      measure_at: this.attr(''),
      type_code: this.attr(null),
      type_name: this.string(''),
      value: this.attr(null),
      unit: this.attr(null),
      unit_name: this.string('')
    }
  }

  get vitalEntry () {
    return VitalEntry.find(this.vital_entry_id)
  }
}
